module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col mt-5"
  }, [_c('router-view')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee7c656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/LiveAuctionLayout.vue
// module id = 1299
// module chunks = 1